module.exports = __webpack_public_path__ + "img/register2.49ea4790.png";